module.exports = __webpack_public_path__ + "static/img/Documentation_v1_SFig7_v2.1c6b87b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/Documentation_v1_SFig7_v2.jpg
// module id = 524
// module chunks = 1